<template lang="pug">
  button.has-text-white.has-text-weight-bold.btn3d.to-click(
    v-bind="$attrs",
    v-on="$listeners",
    :class="{['btn-' + color]: true, ['btn-' + size]: true, 'block': block, 'btn-disabled': active}"
    :disabled="disabled"
  )
    slot
</template>

<script>
export default {
  props: {
    color: {type: String, required: true},
    size: {
      type: String,
      'default': 'small',
      validator (value) {
        return ['small', 'medium', 'large', 'x-tall'].includes(value)
      }
    },
    block: {type: Boolean, 'default': false},
    active: {type: Boolean, 'default': false}, // show the button pressed
    disabled: {type: Boolean, default: false}
  },
  inheritAttrs: false
}
</script>

<style scoped>
button {
  padding-top: 8px;
}
.btn-small {
  min-width: 50px;
  min-height: 15px;
}
.btn-large {
  min-width: 200px;
  min-height: 50px;
}
.btn-medium {
  min-width: 100px;
  min-height: 25px;
}
.btn-x-tall {
  min-height: 250px;
  min-width: 200px;
}
.block {
  width: 100%;
}
</style>
